{
  "familyId": "SWW-TT-DSTAM",
  "questions": [
    {
      "id": "SWW-TT-DSTAM-001",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "multiple_choice",
      "question": "Welke zin bevat een dt-fout?",
      "context": null,
      "options": ["Hij word steeds beter.", "Zij wordt steeds beter.", "Ik word steeds beter.", "Wij worden steeds beter."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "D-stam Regel", "content": "Als de stam eindigt op -d, schrijf je bij hij/zij: d + t = dt. Checkstrategie: zet in ik-vorm (ik word) of maak langer (worden).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "dt_error_recognition",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: dt-regel (d-stam). Stap 1: De stam van 'worden' is 'word' (eindigt op d). Stap 2: Bij hij/zij/het voeg je -t toe: word + t = wordt (dt). Stap 3: Zin 1 mist de -t: 'Hij word' moet 'Hij wordt' zijn. Checkstrategie: zet om naar ik-vorm: 'ik word' (geen t) → dus 'hij wordt' (wel t). Of maak langer: 'worden' → het is een werkwoord, dus hij wordt.",
        "distractorExplanations": {
          "0": "Correct! 'Hij word' is fout. Dt-regel: de stam 'word' eindigt op d, dus bij hij: word + t = wordt (dt).",
          "1": "Geen fout: 'Zij wordt' is juist geschreven. Misconceptie: denken dat 'dt' altijd fout is. Bij hij/zij/het is dt juist: word + t = wordt.",
          "2": "Geen fout: 'Ik word' is juist geschreven. Misconceptie: denken dat ik ook -t krijgt. Bij 'ik' gebruik je alleen de stam: ik word (zonder t).",
          "3": "Geen fout: 'Wij worden' is juist geschreven. Misconceptie: denken dat meervoud ook dt krijgt. Bij wij/jullie/zij gebruik je -en: worden."
        }
      }
    },
    {
      "id": "SWW-TT-DSTAM-002",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "text_highlight",
      "question": "Klik op het woord met een dt-fout in deze zin:",
      "context": "Hij word steeds beter in rekenen.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Hij word steeds beter in rekenen.",
        "correctHighlights": [{"start": 4, "end": 8}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "D-stam Regel", "content": "Als de stam eindigt op -d, schrijf je bij hij/zij: d + t = dt. Checkstrategie: zet in ik-vorm (ik word) of maak langer (worden).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "dt_error_text_highlight",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: dt-regel (d-stam). Stap 1: De stam van 'worden' is 'word' (eindigt op d). Stap 2: Bij hij/zij/het voeg je -t toe: word + t = wordt (dt). Stap 3: 'Hij word' mist de -t → moet 'wordt' zijn. Checkstrategie: 'ik word' (geen t) → 'hij wordt' (wel t), of maak langer: 'worden'.",
        "distractorExplanations": { "1": "Correct! 'Word' moet 'wordt' zijn. Dt-regel: de stam eindigt op d, dus bij hij: word + t = wordt (dt)." }
      }
    },
    {
      "id": "SWW-TT-DSTAM-003",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "text_highlight",
      "question": "Klik op het woord met een dt-fout:",
      "context": "Ik vind dat hij gelijk heeft.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Ik vind dat hij gelijk heeft.",
        "correctHighlights": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "D-stam Regel", "content": "Bij 'ik' gebruik je alleen de stam (geen t). De stam van 'vinden' is 'vind', dus: ik vind (NIET ik vindt).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "dt_error_ik_form",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Regel: dt-regel (d-stam) — truc-vraag! Stap 1: De stam van 'vinden' is 'vind' (eindigt op d). Stap 2: Bij 'ik' gebruik je alleen de stam (geen t): ik vind. Stap 3: Deze zin heeft GEEN dt-fout — 'ik vind' is juist! Checkstrategie: zet om naar hij-vorm: 'hij vindt' (met t) → dus 'ik vind' (zonder t).",
        "distractorExplanations": { "1": "Let op! 'Ik vind' is JUIST. Misconceptie: denken dat 'vind' altijd 'vindt' moet zijn. Bij 'ik' gebruik je alleen de stam (geen t). De fout zou zijn: 'ik vindt' (met t)." }
      }
    },
    {
      "id": "SWW-TT-DSTAM-004",
      "familyId": "SWW-TT-DSTAM",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_d_stam",
      "questionType": "text_highlight",
      "question": "Klik op het woord met een dt-fout:",
      "context": "Zij vind dat het te laat is.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Zij vind dat het te laat is.",
        "correctHighlights": [{"start": 4, "end": 8}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "D-stam Regel", "content": "Bij hij/zij/het voeg je -t toe aan de stam. Als de stam op d eindigt: d + t = dt. Dus: zij vindt (niet vind).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "dt_error_zij_form",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Regel: dt-regel (d-stam). Stap 1: De stam van 'vinden' is 'vind' (eindigt op d). Stap 2: Bij zij voeg je -t toe: vind + t = vindt (dt). Stap 3: 'Zij vind' mist de -t → moet 'vindt' zijn. Checkstrategie: 'ik vind' (geen t) → 'zij vindt' (wel t), of maak langer: 'vinden' → het is een werkwoord, dus zij vindt.",
        "distractorExplanations": { "1": "Correct! 'Vind' moet 'vindt' zijn. Dt-regel: bij zij voeg je -t toe aan de stam: vind + t = vindt (dt)." }
      }
    }
  ]
}
